import { Link } from 'react-router-dom';
import { LogOut, Settings, CreditCard, LayoutDashboard, ChevronDown } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { Button } from '../ui/button';

export function UserDropdown({ user, isAdmin, logout }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-2 text-white/70 hover:text-white hover:bg-white/5" data-testid="user-menu-trigger">
          <div className="w-8 h-8 rounded-full pi-gradient flex items-center justify-center text-white text-sm font-bold">
            {user.name?.[0]?.toUpperCase() || 'U'}
          </div>
          <span className="max-w-[100px] truncate font-space">{user.name || user.email}</span>
          <ChevronDown className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 bg-[#0E1830] border-white/10" align="end">
        <div className="px-3 py-2">
          <p className="text-sm font-medium text-white">{user.name}</p>
          <p className="text-xs text-white/50">{user.email}</p>
          <span className="inline-block mt-1 px-2 py-0.5 text-xs rounded-full pi-gradient text-white font-bold">
            {user.plan?.toUpperCase() || 'FREE'}
          </span>
        </div>
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem asChild className="text-white/70 hover:text-white focus:text-white focus:bg-white/5">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="menu-dashboard"><LayoutDashboard className="w-4 h-4" /> Dashboard</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="text-white/70 hover:text-white focus:text-white focus:bg-white/5">
          <Link to="/dashboard/subscription" className="flex items-center gap-2" data-testid="menu-subscription"><CreditCard className="w-4 h-4" /> Subscription</Link>
        </DropdownMenuItem>
        {isAdmin && (
          <DropdownMenuItem asChild className="text-white/70 hover:text-white focus:text-white focus:bg-white/5">
            <Link to="/admin" className="flex items-center gap-2" data-testid="menu-admin"><Settings className="w-4 h-4" /> Admin Panel</Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem onClick={logout} className="text-red-400 hover:text-red-300 focus:text-red-300 focus:bg-white/5 cursor-pointer" data-testid="menu-logout">
          <LogOut className="w-4 h-4 mr-2" /> Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function MobileMenu({ navLinks, user, isAdmin, logout, onClose }) {
  return (
    <div className="md:hidden py-4 border-t border-white/10">
      <div className="flex flex-col gap-4">
        {navLinks.map((link) => (
          <Link key={link.name} to={link.href} className="text-white/70 hover:text-white py-2" onClick={onClose}>{link.name}</Link>
        ))}
        {user ? (
          <>
            <Link to="/dashboard" className="text-white/70 hover:text-white py-2" onClick={onClose}>Dashboard</Link>
            <button onClick={() => { logout(); onClose(); }} className="text-red-400 hover:text-red-300 py-2 text-left">Logout</button>
          </>
        ) : (
          <>
            <Link to="/login" className="text-white/70 hover:text-white py-2" onClick={onClose}>Login</Link>
            <Link to="/signup" onClick={onClose}><Button className="w-full shimmer-btn text-white rounded-full border-0">Start free</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
